<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="account">
    <h1 class="font-weight-thin display-1 grey--text ml-3 mt-3 hidden-xs-only">
      Current Plan & Billing History
    </h1>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="rounded-card elevation-0">
            <v-card-title primary class="title">
              <span class="primary--text text-lighten-2">
                Current Plan: {{ account ? account.type : '?' }}
              </span>
            </v-card-title>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="blue-grey--text">{{
                    planStatus
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-card-actions class="hidden-xs-only">
              <v-btn to="/account" color="accent" round depressed
                >Check Usage</v-btn
              >
              <v-btn
                v-if="
                  account && !isTrial && !account.cancellation_effective_date
                "
                color="primary"
                round
                outline
                @click="updateBilling"
                >Update Current Payment Details</v-btn
              >
              <v-btn
                v-if="
                  account && !isTrial && !account.cancellation_effective_date
                "
                color="primary"
                round
                outline
                @click="cancelPlan"
                >Cancel Plan</v-btn
              >
            </v-card-actions>
            <v-card-actions class="hidden-sm-and-up">
              <v-btn to="/account" color="accent" round depressed>Check</v-btn>
              <v-btn
                v-if="
                  account && !isTrial && !account.cancellation_effective_date
                "
                color="primary"
                round
                outline
                @click="updateBilling"
                >Update</v-btn
              >
              <v-btn
                v-if="
                  account && !isTrial && !account.cancellation_effective_date
                "
                color="primary"
                round
                outline
                @click="cancelPlan"
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="rounded-card elevation-0">
            <v-card-title primary class="title">
              <span class="primary--text text-lighten-2">
                Available Plans&nbsp;&nbsp;
              </span>
              <v-switch
                v-if="showSwitch"
                v-model="isAnnual"
                label="Pay Annually and Save!"
                class="hidden"
              ></v-switch>
            </v-card-title>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <v-card class="rounded-card elevation-5 grey lighten-4 ma-3">
                  <v-card-title class="primary justify-space-between">
                    <h3 class="mb-0 white--text mr-2">Start</h3>
                    <p class="mb-0 white--text">Great for newsletters</p>
                  </v-card-title>
                  <v-card-text class="text-xs-center">
                    <div v-if="isAnnual" class="mb-4 primary--text display-1">
                      <span>$190</span>
                      <sub>/Yr</sub>
                    </div>
                    <div v-else class="mb-4 primary--text display-1">
                      <span>$19</span>
                      <sub>/Mo</sub>
                    </div>
                    <ul class="list-unstyled primary--text text--darken-1">
                      <!--<li v-if="isAnnual"><v-icon color="success" small>done_all</v-icon> 2 months free</li>-->
                      <li>
                        <v-icon color="success" small>done</v-icon> Use your own
                        Mail Server
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon>
                        <strong>Store up to 25,000 contacts</strong>
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Create
                        unlimited lists
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Drag & drop
                        builder
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Image studio
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> 10,000
                        emails via Groupmail delivery service
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Real-time
                        analytics
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Groupmail
                        branding removed
                      </li>
                      <li class="grey--text text--lighten-1">
                        Priority Support
                      </li>
                    </ul>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      v-if="
                        account &&
                          account.subscription_plan_id &&
                          !account.cancellation_effective_date
                      "
                      block
                      large
                      round
                      color="primary"
                      :disabled="isCurrentPlan('start')"
                      :loading="loading"
                      @click="updatePlan('start')"
                      >{{
                        isCurrentPlan('start') ? 'Current Plan' : 'Change Plan'
                      }}
                    </v-btn>
                    <v-btn
                      v-else
                      block
                      color="primary"
                      round
                      large
                      :loading="loading"
                      @click="startPlan"
                      >Choose Plan</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-card class="rounded-card elevation-5 grey lighten-4 ma-3">
                  <v-card-title class="primary justify-space-between success">
                    <h3 class="mb-0 white--text mr-2">Grow</h3>
                    <p class="mb-0 white--text">For power users</p>
                  </v-card-title>
                  <v-card-text class="text-xs-center">
                    <div v-if="isAnnual" class="mb-4 primary--text  display-1">
                      <span>$490</span>
                      <sub>/Yr</sub>
                    </div>
                    <div v-else class="mb-4 primary--text  display-1">
                      <span>$49</span>
                      <sub>/Mo</sub>
                    </div>
                    <ul class="list-unstyled primary--text text--darken-1">
                      <!--<li v-if="isAnnual"><v-icon color="success" small>done_all</v-icon> 2 months free</li>-->
                      <li>
                        <v-icon color="success" small>done</v-icon> Use your own
                        Mail Server
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon>
                        <strong>Store unlimited contacts</strong>
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Create
                        unlimited lists
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Drag & drop
                        builder
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Image studio
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> 30,000
                        emails via Groupmail delivery service
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Real-time
                        analytics
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Groupmail
                        branding removed
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Priority
                        support
                      </li>
                    </ul>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      v-if="
                        account &&
                          account.subscription_plan_id &&
                          !account.cancellation_effective_date
                      "
                      block
                      large
                      round
                      color="success"
                      :disabled="isCurrentPlan('grow')"
                      :loading="loading"
                      @click="updatePlan('grow')"
                      >{{
                        isCurrentPlan('grow') ? 'Current Plan' : 'Change Plan'
                      }}
                    </v-btn>
                    <v-btn
                      v-else
                      block
                      color="success"
                      round
                      large
                      :loading="loading"
                      @click="growPlan"
                      >Choose plan</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-card class="rounded-card elevation-5 grey lighten-4 ma-3">
                  <v-card-title class="primary justify-space-between warning">
                    <h3 class="mb-0 white--text mr-2">Pro</h3>
                    <p class="mb-0 white--text">For power marketers</p>
                  </v-card-title>
                  <v-card-text class="text-xs-center">
                    <div v-if="isAnnual" class="mb-4 primary--text display-1">
                      <span>$990</span>
                      <sub>/Yr</sub>
                    </div>
                    <div v-else class="mb-4 primary--text display-1">
                      <span>$99</span>
                      <sub>/Mo</sub>
                    </div>
                    <ul class="list-unstyled primary--text text--darken-1">
                      <!--<li v-if="isAnnual"><v-icon color="success" small>done_all</v-icon> 2 months free</li>-->
                      <li>
                        <v-icon color="success" small>done</v-icon> Use your own
                        Mail Server
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon>
                        <strong>Store unlimited contacts</strong>
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Create
                        unlimited lists
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Drag & drop
                        builder
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Image studio
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> 50,000
                        emails via Groupmail delivery service
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Real-time
                        analytics
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Groupmail
                        branding removed
                      </li>
                      <li>
                        <v-icon color="success" small>done</v-icon> Priority
                        support
                      </li>
                    </ul>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      v-if="
                        account &&
                          account.subscription_plan_id &&
                          !account.cancellation_effective_date
                      "
                      block
                      large
                      round
                      color="warning"
                      :loading="loading"
                      :disabled="isCurrentPlan('pro')"
                      @click="updatePlan('pro')"
                      >{{
                        isCurrentPlan('pro') ? 'Current Plan' : 'Change Plan'
                      }}
                    </v-btn>
                    <v-btn
                      v-else
                      block
                      large
                      round
                      color="warning"
                      :loading="loading"
                      @click="proPlan"
                      >Choose plan</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
            <Faq></Faq>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="billingHistory.length">
          <v-card class="rounded-card elevation-0">
            <v-card-title primary class="title">
              <span class="primary--text text-lighten-2">
                Billing History
              </span>
            </v-card-title>
            <v-card-text>
              <Timeline v-bind:history="billingHistory"></Timeline>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
const { detect } = require('detect-browser');
import Faq from '../components/Faq';
import Timeline from '../components/Timeline';

import { mapState, mapGetters, mapActions } from 'vuex';
dayjs.extend(utc);
dayjs.extend(LocalizedFormat);
const browser = detect();

export default {
  name: 'Billing',
  components: { Faq, Timeline },
  data: () => ({
    menu: false,
    showSwitch: true,
    isAnnual: false,
    tabs: null,
    loading: false
  }),
  computed: {
    ...mapState('auth', ['account', 'user', 'team']),
    ...mapGetters('auth', ['isTeamOwner']),
    ...mapGetters('account', ['billingHistory']),
    isTrial() {
      if (this.account) {
        return (
          this.account.status === 'TRIAL' || this.account.status === 'FREE'
        );
      }
      return true;
    },
    existingPlan() {
      // plans current are: Trial, Starter, Business, Marketer, Enterprise & Unlimited
      if (this.account) {
        return this.account.status === 'ACTIVE'
          ? this.account.type
          : this.account.status === 'TRIAL'
          ? 'Trial'
          : this.account.status;
      }
      return 'Unknown';
    },
    planStatus() {
      if (this.account) {
        console.log('Status: ', this.account.status);
        if (this.account.status === 'TRIAL') {
          return `${this.account.status}, expires on ${this.shortDate(
            this.account.expires
          )}`;
        } else if (this.account.status === 'FREE') {
          return `You're on a FREE plan - 5000 contacts / ${this.account
              .dayEmailLimit || 1000} emails - consider upgrading for real-time analytics and larger lists - see options below...`;
        } else if (this.account.status === 'ACTIVE') {
          if (this.account.cancellation_effective_date) {
            return `Cancelled, account active until ${this.shortDate(
              this.account.cancellation_effective_date
            )}`;
          }
          return `${this.account.status}, next billing date: ${this.shortDate(
            this.account.next_bill_date
          )}, interval: ${this.account.billingCycle}`;
        }
        return this.account.status;
      }
      return 'Unknown';
    }
  },
  mounted: async function() {
    await this.loadLatestAccount();
    if (this.$route.query.monthly) {
      const monthly = decodeURIComponent(this.$route.query.monthly);
      if (monthly && typeof monthly !== 'undefined') {
        this.showSwitch = !!monthly;
      }
    }
  },
  methods: {
    ...mapActions('account', ['changePlan', 'getHistory']),
    async loadLatestAccount() {
      await this.$store.dispatch('auth/getAccount');
      await this.$store.dispatch('account/getHistory');
      if (
        this.account &&
        !(this.account.type === 'Trial' || this.account.type === 'Free')
      ) {
        this.isAnnual = !(
          this.account.billingCycle === 'MONTHLY' ||
          this.account.billingCycle === 'NONE'
        );
        if (this.isAnnual === false) this.showSwitch = true;
      }
    },
    startPlan() {
      // 562350
      if (this.user) {
        if (this.isTeamOwner) {
          this.$ga.event({
            eventCategory: 'billing',
            eventAction: 'startPlanSignup',
            eventLabel: this.team._id
          });
          // eslint-disable-next-line
          Paddle.Checkout.open({
            product: this.isAnnual ? 562471 : 562350,
            email: this.user.email,
            passthrough: JSON.stringify({
              teamId: this.team._id,
              userId: this.user._id,
              ip: this.user.ip
            }),
            successCallback: function() {},
            closeCallback: function() {}
          });
        } else {
          this.$dialog.error({
            text: 'Sorry, but only Team Owners can subscribe or alter plans.',
            title: 'Error'
          });
        }
      }
    },
    growPlan() {
      // 562351
      if (this.user) {
        if (this.isTeamOwner) {
          this.$ga.event({
            eventCategory: 'billing',
            eventAction: 'growPlanSignup',
            eventLabel: this.team._id
          });
          // eslint-disable-next-line
          Paddle.Checkout.open({
            product: this.isAnnual ? 562472 : 562351,
            email: this.user.email,
            passthrough: JSON.stringify({
              teamId: this.team._id,
              userId: this.user._id,
              ip: this.user.ip
            }),
            successCallback: function() {},
            closeCallback: function() {}
          });
        } else {
          this.$dialog.error({
            text: 'Sorry, but only Team Owners can subscribe or alter plans.',
            title: 'Error'
          });
        }
      }
    },
    proPlan() {
      // 562352
      if (this.user) {
        if (this.isTeamOwner) {
          this.$ga.event({
            eventCategory: 'billing',
            eventAction: 'proPlanSignup',
            eventLabel: this.team._id
          });
          // eslint-disable-next-line
          Paddle.Checkout.open({
            product: this.isAnnual ? 562473 : 562352,
            email: this.user.email,
            passthrough: JSON.stringify({
              teamId: this.team._id,
              userId: this.user._id,
              ip: this.user.ip
            }),
            successCallback: function() {},
            closeCallback: function() {}
          });
        } else {
          this.$dialog.error({
            text: 'Sorry, but only Team Owners can subscribe or alter plans.',
            title: 'Error'
          });
        }
      }
    },
    updateBilling() {
      if (this.account) {
        if (this.isTeamOwner) {
          if (this.account.update_url) {
            this.$ga.event({
              eventCategory: 'billing',
              eventAction: 'updateBilling',
              eventLabel: this.team._id
            });
            if (browser && browser.name !== 'safari') {
              // eslint-disable-next-line
              Paddle.Checkout.open({
                override: this.account.update_url,
                email: this.user.email,
                passthrough: JSON.stringify({
                  teamId: this.team._id,
                  userId: this.user._id,
                  ip: this.user.ip
                })
              });
            } else {
              window.open(this.account.update_url, '_blank');
            }
          }
        } else {
          this.$dialog.error({
            text: 'Sorry, but only Team Owners can subscribe or alter plans.',
            title: 'Error'
          });
        }
      }
    },
    cancelPlan() {
      if (this.account) {
        if (this.isTeamOwner) {
          if (this.account.cancel_url) {
            this.$ga.event({
              eventCategory: 'billing',
              eventAction: 'cancelPlan',
              eventLabel: this.team._id
            });
            if (browser && browser.name !== 'safari') {
              // eslint-disable-next-line
              Paddle.Checkout.open({
                override: this.account.cancel_url,
                email: this.user.email,
                passthrough: JSON.stringify({
                  teamId: this.team._id,
                  userId: this.user._id,
                  ip: this.user.ip
                }),
                successCallback: function() {},
                closeCallback: function() {}
              });
            } else {
              window.open(this.account.cancel_url, '_blank');
            }
          }
        } else {
          this.$dialog.error({
            text: 'Sorry, but only Team Owners can subscribe or alter plans.',
            title: 'Error'
          });
        }
      }
    },
    isCurrentPlan(subType) {

      if (this.account && !(this.account.type === 'Free')) {
        if (subType === 'start') {
          if (this.isAnnual) {
            return this.account.subscription_plan_id === 562471; // annual
          }
          return this.account.subscription_plan_id === 562350; // monthly
        }
        if (subType === 'grow') {
          if (this.isAnnual) {
            return this.account.subscription_plan_id === 562472; // annual
          }
          return this.account.subscription_plan_id === 562351; // monthly
        }
        if (subType === 'pro') {
          if (this.isAnnual) {
            return this.account.subscription_plan_id === 562473; // annual
          }
          return this.account.subscription_plan_id === 562352; // monthly
        }
      }
      return false;
    },
    async updatePlan(subType) {
      // this.account

      // subscription_id
      // subscription_plan_id
      if (this.account) {
        const res = await this.$dialog.confirm({
          text: 'Are you sure you wish to change to this plan?',
          title: 'Change Plan?',
          actions: {
            false: {
              text: 'Cancel',
              color: 'primary'
            },
            true: {
              text: 'Change Plan',
              color: 'accent'
            }
          }
        });
        if (res) {
          const subscription_id = this.account.subscription_id;
          let plan_id;
          if (subType === 'start') {
            if (this.isAnnual) {
              plan_id = 562471;
            } else {
              plan_id = 562350;
            }
          } else if (subType === 'grow') {
            if (this.isAnnual) {
              plan_id = 562472;
            } else {
              plan_id = 562351;
            }
          } else {
            if (this.isAnnual) {
              plan_id = 562473;
            } else {
              plan_id = 562352;
            }
          }
          this.loading = true;
          const result = await this.changePlan({ subscription_id, plan_id });
          this.loading = false;
          if (result && result.success) {
            // next_payment: { amount: 3.01, currency: 'EUR', date: '2019-07-07' }
            this.setSnack('Plan changed successfully');
            this.$dialog.message({
              text: `Success. Next payment (of ${result.amount}${
                result.currency
              }) is due on ${this.shortDate(result.date)}`,
              title: 'Change Plan'
            });
          } else if (result && !result.success) {
            this.$dialog.error({
              text:
                result.error.message ||
                'Change of plan failed. Unknown reason. Please try refreshing your browser and/or contact Support',
              title: 'Error'
            });
          }
        }
      }
    },
    shortDate(dateString) {
      return dayjs.utc(dateString).format('ll');
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
.flexcard {
  display: flex;
  flex-direction: column;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
</style>
